/* tslint:disable */
/* eslint-disable */
export enum ApplicationEnum {
  Mpa = 'MPA',
  MeepointBusiness = 'MEEPOINT_BUSINESS',
  Meepoint = 'MEEPOINT'
}
